import Vue from 'vue'
import store from '@/store/store.js'
import router from '@/router/router.js'
import VueCookies from 'vue-cookies'
import { v4 as uuidv4 } from 'uuid'
import Utils from '@/utils/index.js'
import { EventBus } from '@/utils/event-bus.js'
import imgPreview from '@/components/Preview/index.js'
import VueLazyload from 'vue-lazyload'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import Vlf from 'vlf'
import localforage from 'localforage'
import 'swiper/css/swiper.css'
import '@/styles/body.less'
import '@/directive'
import '@/components/install'
import { loadImg } from '@/components/Prefetch'
import LazyImage from '@/components/LazyImage.vue'
import MetaInfo from 'vue-meta-info'
import config from './http/config'
import App from './App.vue'

Vue.config.productionTip = false
Vue.prototype.$Utils = Utils
Vue.prototype.$Uuidv4 = uuidv4
Vue.prototype.$EventBus = EventBus // 通知其他兄弟组件

Vue.component('Swiper', Swiper)
Vue.component('SwiperSlide', SwiperSlide)
Vue.component('LazyImage', LazyImage)

Vue.use(VueCookies)
Vue.use(imgPreview)
Vue.use(Vlf, localforage)
Vue.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 1
})
Vue.use(MetaInfo)

window.addEventListener('load', () => {
    if (document.readyState === 'complete') {
        console.log('所有资源已加载完成')
        loadImg()
    }
})

// 仅测试环境检测和预发布环境检测前端代码是否有更新
if (location.hostname == 'testbox.steamf.cn' || location.hostname == 'betabox.steamf.cn') {
    let url = ''
    if (location.hostname == 'testbox.steamf.cn') {
        url = 'https://testbox.steamf.cn/main/v.json'
    } else {
        url = 'https://betabox.steamf.cn/main/v.json'
    }
    VersionPolling.createVersionPolling({
        appETagKey: '__APP_ETAG__',
        htmlFileUrl: url,
        pollingInterval: 5 * 1000,
        spliceTime: true,
        onUpdate: (self) => {
            Vue.prototype.$NormalDialog.show({ msg: '页面有更新，请按ctrl+shift+r强制刷新页面(仅测试和预发布)' })
        }
    })
}

Vue.prototype.$localGame = Vue.prototype.$vlf.createInstance({
    name: 'box_website',
    storeName: 'localGame'
})

let vueThis = ''
function initVue() {
    /* if (Utils.judgeDevice() !== 'other') {
        // 在手机设备上打开PC的拼团活动页面，直接跳转到移动端的
        window.location.replace(`${config.WEB_DOMAIN}/group.html?group_id=${Utils.getUrlParams().group_id}`)
        return false
    } */

    vueThis = new Vue({
        router,
        store,
        render: (h) => h(App)
    }).$mount('#app')
    window.$Expose = vueThis
}

initVue()

export { vueThis }
